module.exports = __webpack_public_path__ + "img/2020_12.d027caba.jpg";